import { Injectable } from '@angular/core';
import { CoreRepository, Response } from '@tcc-mono/shared/data-access';
import { Animal, PurchaseInvoice, PurchaseOrderAnimal, Ride, SalesInvoice, TransportGroup } from '@tcc-mono/vandijk/shared/data-access/models';
import { AnimalService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable, filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnimalRepository extends CoreRepository<Animal> {

  public animals$: Observable<Animal[]> = this.entities$;
  public selectedAnimal$: Observable<Animal> = this.activeEntity$;

  public constructor(
    protected readonly _animalService: AnimalService
  ) {
    super(
      { name: 'animals' },
      _animalService
    )
  }

  public addAnimal = (animal: Partial<Animal>): Observable<Animal> => {
    return this.addEntity(animal);
  }

  public updateAnimal = (animalId: number, animal: Animal): Observable<Animal> => {
    return this.updateEntity(animalId, animal);
  }

  public getAnimal = (animalId: number): Observable<Animal> => {
    return this.getEntity(animalId);
  }

  public removeAnimal = (animalId: number): Observable<unknown> => {
    return this.removeEntity(animalId);
  }

  public setActiveAnimal = (animalId: number): void => {
    this.setActiveEntity(animalId);
  }

  public getAnimalPurchaseOrder = (animalId: number): Observable<PurchaseOrderAnimal> => {
    return this._animalService.getChild(animalId, 'purchase_order_line')
      .pipe(
        map(res => res as Response<PurchaseOrderAnimal>),
        filter((res) => !!res?.data),
        map((result: Response<PurchaseOrderAnimal>) => result?.data)
      );
  }

  public getAnimalRide(animalId: number): Observable<Ride> {
    return this._animalService.getChild(animalId, '/ride')
      .pipe(
        map(res => res as Response<Ride>),
        map((result: Response<Ride>) => result?.data)
      );
  }

  public getAnimalPurchaseInvoice(animalId: number): Observable<PurchaseInvoice> {
    return this._animalService.getChild(animalId, '/purchase-invoice')
      .pipe(
        map(res => res as Response<PurchaseInvoice>),
        map((result: Response<PurchaseInvoice>) => result?.data)
      );
  }

  public getAnimalSalesInvoice(animalId: number): Observable<SalesInvoice> {
    return this._animalService.getChild(animalId, '/sales-invoice')
      .pipe(
        map(res => res as Response<SalesInvoice>),
        map((result: Response<SalesInvoice>) => result?.data)
      );
  }

  public getAnimalTransportGroup = (animalId: number): Observable<TransportGroup> => {
    return this._animalService.getChild(animalId, 'transport_group')
      .pipe(
        map(res => res as Response<TransportGroup>),
        map((result: Response<TransportGroup>) => result?.data)
      );
  }
}
